import type {
  DocumentApiResponse,
  DocumentClassification,
  DocumentFailureReason,
  DocumentType,
  DocumentVideoAnalysis,
} from "@recobra/schemas/document";

type DisplayDocumentStatus =
  | "idle"
  | "requesting-url"
  | "uploading"
  | "upload-error"
  | "pending"
  | "uploaded"
  | "classifying"
  | "classified"
  | "failed";

export type DisplayDocument = {
  id: string;
  filename: string;
  mimeType: string;
  sizeBytes: number;
  fileFingerprint?: string;
  status: DisplayDocumentStatus;
  failureReason?: DocumentFailureReason;
  uploadProgress?: number;
  uploadErrorMessage?: string;
  thumbnailUrl?: string;
  viewUrl?: string;
  documentType?: string;
  classification?: DocumentClassification;
  videoAnalysis?: DocumentVideoAnalysis;
  classificationOverride?: {
    documentType: DocumentType;
    overriddenBy: string;
    overriddenAt: string;
  };
  isProblematic?: boolean;
  createdAt?: string;
  /** Per-document note from the case Analyse step. Takes priority over classification explanation. */
  analysisNote?: string;
};

export const displayDocFromRecord = (doc: DocumentApiResponse): DisplayDocument => ({
  id: doc.id,
  filename: doc.filename ?? "",
  mimeType: doc.mimeType ?? "application/octet-stream",
  sizeBytes: doc.sizeBytes ?? 0,
  fileFingerprint: doc.fileFingerprint,
  status: doc.status ?? "pending",
  failureReason: doc.failureReason,
  thumbnailUrl: doc.thumbnailUrl,
  viewUrl: doc.viewUrl,
  documentType: doc.documentType ?? undefined,
  classification: doc.classification,
  videoAnalysis: doc.videoAnalysis,
  classificationOverride: doc.classificationOverride,
  isProblematic: doc.notRelatedToCurrentCase,
  createdAt: doc.createdAt,
});
